import React from "react";

export default function SignupConfirm() {
  return (
    <div className="text-center">
      <h3>회원가입을 축하합니다.</h3>
      <h3>Email is verified! Thank you.!</h3>
    </div>
  );
}